export default __webpack_public_path__ + "static/media/ico_guide.915d1d15.svg";